import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, DataTable, Header, Heading } from "grommet";
import { get } from "lodash";
import React, { useEffect } from "react";
import { getOrganizationUsage, getOverallUsage, OrganizationUsageDetail } from "./BillingStore";

import * as XLSX from "xlsx";
import { useParams } from "react-router-dom";
import SkeletonWrapper from "../components/SkeletonWrapper";
import { TeamGrid, TeamTile } from "../teams/TeamsManagement";
import { TournamentRow } from "../tournaments/TournamentRow";
import { LeagueRow } from "../leagues/LeagueRow";
import { SeasonRow } from "../seasons/SeasonRow";
import { AliasTile } from "../aliases/AliasTile";

const OrganizationUsage = () => {
    const [loading, setLoading] = React.useState(true);
    const [usage, setUsage] = React.useState({} as OrganizationUsageDetail);

    const { id } = useParams();

    useEffect(() => {
        getOrganizationUsage(id).then((res) => {
            setUsage(res.result);
            setLoading(false);
        });
    }, [id]);

    return (
        <>
            <SkeletonWrapper loading={loading}>
                <Heading size="small">{usage.name}</Heading>
                <Heading size="small">Aliases</Heading>
                <Box direction="row" wrap gap="small">
                    {usage.aliases?.map((alias) => (
                        <AliasTile key={alias.id} alias={alias}></AliasTile>
                    ))}
                </Box>
                <Heading size="small">Teams</Heading>
                <Box direction="row" wrap gap="small">
                    {usage.teams?.map((team) => (
                        <Box key={team.id} margin={{ bottom: "small" }}>
                            <TeamTile team={team}></TeamTile>
                        </Box>
                    ))}
                </Box>
                <Heading size="small">Tournaments</Heading>
                <Box gap="small">
                    {usage.tournaments?.map((tournament) => (
                        <TournamentRow key={tournament.id} tournament={tournament}>
                            <></>
                        </TournamentRow>
                    ))}
                </Box>
                <Heading size="small">Leagues</Heading>
                <Box gap="small">
                    {usage.leagues?.map((league) => (
                        <LeagueRow key={league.id} league={league}>
                            <></>
                        </LeagueRow>
                    ))}
                </Box>
            </SkeletonWrapper>
        </>
    );
};

export default OrganizationUsage;
